import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { NavigationContainer } from "@react-navigation/native";
import { TokenWatcher } from "../components/Auth/TokenWatcher";
import LandingScreen from "../screens/Login/LandingScreen";
import LoginScreen from "../screens/Login/LoginScreen";
import TimeTrackingScreen from "../screens/TimeTracking/TimeTrackingScreen";
import RequestEntryApprovalScreen from "../screens/Request/RequestEntryApprovalScreen";
import ResponsiveTabs from "./ResponsiveTabs";

import { useAuth } from "../context/Auth/AuthContext";
import Header from "./Header";
import { Platform, useWindowDimensions } from "react-native";

const Stack = createStackNavigator();

export default function Navigation() {
  const { isAuthenticated } = useAuth();

  const { width } = useWindowDimensions();

  const isMobile = Platform.OS !== "web" || width < 768;

  return (
    <NavigationContainer>
      <TokenWatcher /> 
      {/* {isMobile &&  */}
      {isAuthenticated && <Header /> }
      {/* } */}
      <Stack.Navigator screenOptions={{ headerShown: false }}>
        {!isAuthenticated ? (
          <>
            <Stack.Screen name="Login" component={LandingScreen} />
          </>
        ) : (
          <>
            <Stack.Screen name="App" component={ResponsiveTabs} />
          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
}
